<template>
  <div class="mr-4 ml-4 inner-addon right-addon">
    <i class="glyphicon icon sli-magnifier"></i>
    <input type="text" ref="searchText" :placeholder="placeholder" class="form-control" v-on:input="textChanged"/>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  created () {
    this.handleDebouncedChange = debounce(this.handleSearchEvent, 3000)
  },
  props: [ 'placeholder' ],
  methods: {
    textChanged: function (evt) {
      this.handleDebouncedChange(evt)
    },
    handleSearchEvent: function (evt) {
      this.$emit('textChanged', evt.target.value)
    }
  }
}
</script>

<style>
/* enable absolute positioning */
.inner-addon {
    position: relative;
}

/* style icon */
.inner-addon .glyphicon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

/* align icon */
.left-addon .glyphicon  { left:  0px;}
.right-addon .glyphicon { right: 0px;}

/* add padding  */
.left-addon input  { padding-left:  30px; }
.right-addon input { padding-right: 30px; }
</style>



// WEBPACK FOOTER //
// src/components/SearchField.vue